// src/components/ui/CustomButton.js
import styled from 'styled-components';

const GreenButton = styled.button`
  background-color: #E5F7EE;
  color: #008000;
  font-size: 16px;
  font-weight: 600;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #d3f0e2;
  }

  @media (max-width: 780px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

export default GreenButton;
